// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","494":"component---src-templates-project-details-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"2e144cc43e389773c62e","494":"23c2bea5082adbfc9c12","678":"9cca31130f096b2c38ce","883":"2b5bb74217097e90d8cb"}[chunkId] + ".js";
};